import {
  Box,
  Button,
  Card,
  Container,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import img_arrow_left from "../../assets/img/arrow-left.svg";
import * as Yup from "yup";
import { Formik } from "formik";
import { forgotPassword, restorePassword } from "service/api";
import { useNavigate, useParams, Link } from "react-router-dom";
// import { PUBLIC_URL } from "config";

const BtnBackToAuth = () => {
  return (
    <Link to={"/auth/signin"}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",

          color: "#475467",
          fontWeight: "600",
          lineHeight: "20px",
          fontSize: "14px",
        }}
      >
        <Box
          component={"img"}
          src={img_arrow_left}
          height={"20px"}
          mr={"8px"}
        />
        <Typography>Вернуться на авторизацию</Typography>
      </Box>
    </Link>
  );
};

export const ForgotPassword = () => {
  const [reset, setReset] = useState(false);
  const [email, setEmail] = useState("");

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Некорректный Email")
      .required("Обязательное поле"),
  });

  const ForgotPasswordForm = () => {
    return (
      <Box
        sx={{
          m: "0 auto",
          width: "440px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography fontWeight={"600"} fontSize={"30px"}>
          Забыли пароль?
        </Typography>
        <Typography>
          Отправим ссылку для восстановления на электронный адрес
        </Typography>
        <Card sx={{ mt: "32px", p: "32px 40px", width: "100%" }}>
          <Formik
            initialValues={{
              email: email,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              try {
                const resp = await forgotPassword({ email: values.email });
                if (resp.err) {
                  alert(resp.err);
                  return;
                }
                setReset(true);
                setEmail(values.email);
              } catch (error) {
                alert(error);
              }
            }}
          >
            {({ handleSubmit, errors, handleChange }) => (
              <form onSubmit={handleSubmit}>
                <Box>
                  <Box>
                    <InputLabel sx={{ mb: "6px" }}>
                      Электронный адрес*
                    </InputLabel>
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Введите электронный адрес"
                      name="email"
                      error={errors["email"] ? true : false}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box mt={"24px"}>
                    <Button variant="contained" fullWidth type="submit">
                      Сбросить пароль
                    </Button>
                  </Box>
                </Box>
              </form>
            )}
          </Formik>
        </Card>
        <Box sx={{ mt: "32px", display: "flex" }}>
          <BtnBackToAuth />
        </Box>
      </Box>
    );
  };

  const ForgotPasswordFinish = () => {
    return (
      <Box
        sx={{
          m: "0 auto",
          width: "440px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography fontWeight={"600"} fontSize={"30px"}>
          Проверьте электронный адрес
        </Typography>
        <Typography>Отправили ссылку для сброса пароля на {email}</Typography>
        <Box sx={{ mt: "32px", display: "flex" }}>
          <BtnBackToAuth />
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Box sx={{ bgcolor: "#F9FAFB", height: "100vh" }}>
        <Container sx={{ pt: "96px" }}>
          {!reset ? <ForgotPasswordForm /> : <ForgotPasswordFinish />}
        </Container>
      </Box>
    </>
  );
};

export const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    password: Yup.string().min(8).required("Обьязательное поле"),
  });

  return (
    <>
      <Box sx={{ bgcolor: "#F9FAFB", minHeight: "100vh" }}>
        <Container sx={{ pt: "96px" }}>
          <Box
            sx={{
              m: "0 auto",
              width: "440px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography fontWeight={"600"} fontSize={"30px"}>
              Введите новый пароль
            </Typography>
            <Card sx={{ mt: "32px", p: "32px 40px", width: "100%" }}>
              <Formik
                initialValues={{
                  password: "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  try {
                    const res = await restorePassword({
                      password: values.password,
                      token: token ?? "",
                    });
                    if (res.err) {
                      alert(res.err);
                      return;
                    }
                    navigate("/auth/signin");
                  } catch (error) {
                    alert(error);
                  }
                }}
              >
                {({ handleSubmit, errors, handleChange }) => (
                  <form onSubmit={handleSubmit}>
                    <Box>
                      <Box>
                        <InputLabel sx={{ mb: "6px" }}>Пароль</InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="••••••••"
                          type={"password"}
                          name="password"
                          error={errors["password"] ? true : false}
                          onChange={handleChange}
                        />
                        <Typography mt={"8px"} color={"#475467"}>
                          Минимум 8 символов
                        </Typography>
                      </Box>
                      <Box mt={"24px"}>
                        <Button variant="contained" fullWidth type="submit">
                          Сбросить пароль
                        </Button>
                      </Box>
                    </Box>
                  </form>
                )}
              </Formik>
            </Card>
            <Box sx={{ mt: "32px", display: "flex" }}>
              <BtnBackToAuth />
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};
